export const renameStatusAcc = (number) => {
  let result = "";
  switch (number) {
    case 0:
      result = "Không kích hoạt";
      break;
    case 1:
      result = "Đang kích hoạt";
      break;
    default:
  }
  return result;
};
export const revertCategorieNews = (number) => {
  let result = "";
  switch (number) {
    case 1:
      result = "Thông báo";
      break;
    case 2:
      result = "Khuyến cáo";
      break;
    case 3:
      result = "Cảnh báo";
      break;
    case 4:
      result = "Tin tức an ninh";
      break;
    case 5:
      result = "Tin tức";
      break;
    default:
  }
  return result;
};
export const renameStatusProduct = (number) => {
  let result = "";
  switch (number) {
    case 1:
      result = "Còn hàng";
      break;
    case 0:
      result = "Hết hàng";
      break;
    default:
  }
  return result;
};
export const renameTypeAcc = (number) => {
  let result = "";
  switch (number) {
    case 1:
      result = "Super Admin";
      break;
    case 2:
      result = "Post Admin and Product Admin";
      break;
    case 3:
      result = "Post Admin";
      break;
    case 4:
      result = "Product Admin";
      break;
    default:
  }
  return result;
};
export const revertTypeAcc = (string) => {
  let result = "";
  switch (string) {
    case "Post Admin":
      result = 3;
      break;
    case "Product Admin":
      result = 4;
      break;
    case "Super Admin":
      result = 1;
      break;
    case "Post Admin and Product Admin":
      result = 2;
      break;
    default:
  }
  return result;
};

export const renameTypeDeal = (num) => {
  let result = "";
  switch (num) {
    case 1:
      result = "Chưa diễn ra";
      break;
    case 2:
      result = "Đang diễn ra";
      break;
    case 3:
      result = "Kết thúc";
      break;

    default:
  }
  return result;
};
export const renameLimitDeal = (num) => {
  let result = "";
  switch (num) {
    case 0:
      result = "Tất cả";
      break;
    case 1:
      result = "Nhóm";
      break;
    case 2:
      result = "Số lượng";
      break;

    default:
  }
  return result;
};
